import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { fetchData } from './utils/functions';
import { capitalizeFirstLetter } from './utils/functions';
import ItemSearch from './utils/item-search/ItemSearch';

export default function BrowsePage() {
  const navigate = useNavigate();
  const itemTagQuery = useQuery('itemTagData', () => fetchData('item-tag'));
  const tagQuery = useQuery('tagData', () => fetchData('tag'));

  const getMostCommonTags = (items, tags) => {
    // Count occurrences of each tag_id
    const tagCounts = items.reduce((acc, item) => {
      acc[item.tag_id] = (acc[item.tag_id] || 0) + 1;
      return acc;
    }, {});
  
    // Get the five most common tag_ids
    const mostCommonIds = Object.entries(tagCounts)
      .sort((a, b) => b[1] - a[1]) // Sort by count, descending
      .slice(0, 5) // Take the top 5
      .map(([tagId]) => parseInt(tagId)); // Extract and convert to integer
  
    // Match tag_ids to names
    const matchedTags = mostCommonIds.map((tagId) => {
      const tag = tags.find((t) => t.id === tagId);
      return tag ? tag.name : null; // Safeguard in case a tag isn't found
    }).filter(Boolean); // Remove null values
  
    // Return buttons for each name
    return matchedTags.map((name) => (
      <button key={name} onClick={() => handleClick(name)}>
        {capitalizeFirstLetter(name)}
      </button>
    ));
  };

  const handleClick = (tagName) => {
    const tag = tagQuery.data.find(tag => tag.name === tagName);
    if (tag) {
      navigate(`/cats/search/tag=${tag.id}`);
    }
  }

  return (
    <div>
      {tagQuery.data && (
        <div>
          {itemTagQuery.data && (
            <div>
              <div>
                Quick Tag Search Options:
              </div>
              {getMostCommonTags(itemTagQuery.data, tagQuery.data)}
            </div>
          )}
          <br />
          <ItemSearch />
        </div>
      )}
    </div>
  );
}
